import { useEffect, useState } from "react";

const KEY = "jungle-depositos";
const OLD_KEY = "jungle-deposito";
const newId = () => `t${Date.now().toString(36)}${Math.random().toString(36).slice(2, 6)}`;

const load = () => {
  try {
    const s = JSON.parse(localStorage.getItem(KEY));
    if (Array.isArray(s?.tanks) && s.tanks.length) return s;
    const old = JSON.parse(localStorage.getItem(OLD_KEY)) || {};
    const t = { id: newId(), name: "Mi depósito", liters: old.liters ?? "20", plants: old.plants ?? "4" };
    return { tanks: [t], active: t.id };
  } catch {
    const t = { id: newId(), name: "Mi depósito", liters: "20", plants: "4" };
    return { tanks: [t], active: t.id };
  }
};

export const useTanks = () => {
  const [state, setState] = useState(load);
  useEffect(() => {
    try { localStorage.setItem(KEY, JSON.stringify(state)); } catch { /* storage blocked */ }
  }, [state]);
  const tank = state.tanks.find((t) => t.id === state.active) ?? state.tanks[0];
  const update = (patch) => setState((s) => ({ ...s, tanks: s.tanks.map((t) => (t.id === tank.id ? { ...t, ...patch } : t)) }));
  const select = (id) => setState((s) => ({ ...s, active: id }));
  const add = () => setState((s) => {
    const t = { id: newId(), name: `Depósito ${s.tanks.length + 1}`, liters: "20", plants: "4" };
    return { tanks: [...s.tanks, t], active: t.id };
  });
  const remove = () => setState((s) => {
    const tanks = s.tanks.filter((t) => t.id !== tank.id);
    return tanks.length ? { tanks, active: tanks[0].id } : s;
  });
  return { tanks: state.tanks, tank, update, select, add, remove };
};
